const AiEditorCard = () => (
  <div className="absolute inset-0">
    <svg viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg" className="h-full w-full">
      <defs>
        <radialGradient id="aePink" cx="10%" cy="90%" r="60%">
          <stop offset="0%" stopColor="#F9A8D4" />
          <stop offset="100%" stopColor="#FDF4FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="aePurple" cx="90%" cy="10%" r="60%">
          <stop offset="0%" stopColor="#C4B5FD" />
          <stop offset="100%" stopColor="#FDF4FF" stopOpacity="0" />
        </radialGradient>
        <clipPath id="aeOuter">
          <rect x="10" y="10" width="380" height="280" rx="14" />
        </clipPath>
        <clipPath id="aeRight">
          <rect x="172" y="10" width="218" height="280" rx="0" />
        </clipPath>
        <clipPath id="aeTopRight">
          <rect x="172" y="10" width="218" height="84" rx="0" />
        </clipPath>
      </defs>

      {/* ── Background gradient ── */}
      <rect width="400" height="300" fill="#FDF4FF" />
      <rect width="400" height="300" fill="url(#aePink)" />
      <rect width="400" height="300" fill="url(#aePurple)" />

      {/* ── Outer white container ── */}
      <rect x="10" y="10" width="380" height="280" rx="14" fill="white"
        style={{ filter: "drop-shadow(0 4px 24px rgba(0,0,0,0.08))" }} />

      {/* ══════════════════════════════════════
          LEFT PANEL  (x=10 → x=172, w=162)
          ══════════════════════════════════════ */}

      {/* Tab bar bg */}
      <rect x="10" y="10" width="162" height="28" rx="0" fill="#F9FAFB" clipPath="url(#aeOuter)" />

      {/* ★ Chats tab (active) */}
      <circle cx="24" cy="24" r="4" fill="#EC4899" />
      <text x="31" y="28" fontFamily="Inter,sans-serif" fontSize="9" fontWeight="700" fill="#111827">Chats</text>
      {/* Underline */}
      <rect x="18" y="37" width="32" height="1.5" rx="1" fill="#111827" />

      {/* Manual + Styles */}
      <text x="72" y="28" fontFamily="Inter,sans-serif" fontSize="8.5" fill="#9CA3AF">Manual</text>
      <text x="112" y="28" fontFamily="Inter,sans-serif" fontSize="8.5" fill="#9CA3AF">Styles</text>

      {/* Tab bar bottom border */}
      <line x1="10" y1="38" x2="172" y2="38" stroke="#E5E7EB" strokeWidth="0.8" />

      {/* ── AI greeting bubble ── */}
      <rect x="16" y="44" width="150" height="46" rx="8" fill="#F3F4F6" />
      <text x="22" y="56" fontFamily="Inter,sans-serif" fontSize="8" fontWeight="600" fill="#111827">Hello, José! 👋</text>
      <text x="22" y="67" fontFamily="Inter,sans-serif" fontSize="7" fill="#374151">I am Graphy AI. What changes</text>
      <text x="22" y="77" fontFamily="Inter,sans-serif" fontSize="7" fill="#374151">do you want in your website?</text>

      {/* ── User message (right-aligned) ── */}
      <rect x="50" y="96" width="116" height="14" rx="7" fill="#EEF2FF" />
      <text x="108" y="106" fontFamily="Inter,sans-serif" fontSize="6.5" fill="#4338CA" textAnchor="middle">Create a programs section</text>
      <rect x="68" y="113" width="98" height="14" rx="7" fill="#EEF2FF" />
      <text x="117" y="123" fontFamily="Inter,sans-serif" fontSize="6.5" fill="#4338CA" textAnchor="middle">with course cards</text>

      {/* Aaron C. attribution */}
      <circle cx="156" cy="136" r="6" fill="#FDE68A" />
      <text x="156" y="139" fontFamily="Inter,sans-serif" fontSize="6" fill="#92400E" textAnchor="middle">AC</text>
      <text x="148" y="139" fontFamily="Inter,sans-serif" fontSize="6.5" fill="#9CA3AF" textAnchor="end">Aaron C.</text>

      {/* ── Actions taken block ── */}
      <rect x="16" y="146" width="150" height="62" rx="8" fill="#F0FDF4" />
      <text x="22" y="158" fontFamily="Inter,sans-serif" fontSize="7.5" fontWeight="600" fill="#15803D">3 actions taken</text>
      <text x="148" y="158" fontFamily="Inter,sans-serif" fontSize="8" fill="#15803D" textAnchor="end">∧</text>

      {/* Check 1 */}
      <circle cx="27" cy="169" r="5" fill="#22C55E" />
      <path d="M24.5 169 l2 2 4-4" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <text x="35" y="172" fontFamily="Inter,sans-serif" fontSize="7" fill="#166534">Creating section layout</text>

      {/* Check 2 */}
      <circle cx="27" cy="183" r="5" fill="#22C55E" />
      <path d="M24.5 183 l2 2 4-4" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <text x="35" y="186" fontFamily="Inter,sans-serif" fontSize="7" fill="#166534">Adding course cards</text>

      {/* Check 3 */}
      <circle cx="27" cy="197" r="5" fill="#22C55E" />
      <path d="M24.5 197 l2 2 4-4" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <text x="35" y="200" fontFamily="Inter,sans-serif" fontSize="7" fill="#166534">Creating a new version</text>

      {/* ── Response text ── */}
      <text x="16" y="220" fontFamily="Inter,sans-serif" fontSize="7" fill="#374151">I&apos;ve successfully added a Programs</text>
      <text x="16" y="230" fontFamily="Inter,sans-serif" fontSize="7" fill="#374151">section with course cards.</text>

      {/* ── Input field ── */}
      <rect x="16" y="246" width="150" height="22" rx="8" fill="white" stroke="#E5E7EB" strokeWidth="1" />
      <text x="23" y="260" fontFamily="Inter,sans-serif" fontSize="6.5" fill="#9CA3AF">Select anything to edit...</text>
      {/* send icon */}
      <circle cx="159" cy="257" r="6" fill="#6366F1" />
      <path d="M156.5 259 l5-2 -5-2 0 4" fill="white" />

      {/* ── Add section ── */}
      <text x="22" y="279" fontFamily="Inter,sans-serif" fontSize="7.5" fill="#6366F1">+ Add section</text>

      {/* Panel divider */}
      <line x1="172" y1="10" x2="172" y2="290" stroke="#E5E7EB" strokeWidth="0.8" />

      {/* ══════════════════════════════════════
          RIGHT PANEL  (x=172 → x=390, w=218)
          ══════════════════════════════════════ */}

      {/* Dark olive top section */}
      <rect x="172" y="10" width="218" height="82" fill="#2A2A1E" clipPath="url(#aeOuter)" />
      <text x="178" y="30" fontFamily="Inter,sans-serif" fontSize="8" fontWeight="600" fill="white">Here&apos;s how we enhance</text>
      <text x="178" y="41" fontFamily="Inter,sans-serif" fontSize="8" fontWeight="600" fill="white">your yoga experience</text>
      <text x="178" y="52" fontFamily="Inter,sans-serif" fontSize="6.5" fill="rgba(255,255,255,0.55)">From expert guidance to flexible scheduling,</text>
      <text x="178" y="61" fontFamily="Inter,sans-serif" fontSize="6.5" fill="rgba(255,255,255,0.55)">our program fits seamlessly into your life.</text>

      {/* 3 feature boxes */}
      <rect x="176" y="66" width="64" height="20" rx="4" fill="rgba(255,255,255,0.10)" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" />
      <text x="208" y="79" fontFamily="Inter,sans-serif" fontSize="5.5" fill="rgba(255,255,255,0.85)" textAnchor="middle">Expert-Led Classes</text>

      <rect x="246" y="66" width="64" height="20" rx="4" fill="rgba(255,255,255,0.10)" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" />
      <text x="278" y="79" fontFamily="Inter,sans-serif" fontSize="5.5" fill="rgba(255,255,255,0.85)" textAnchor="middle">Online &amp; In-Studio</text>

      <rect x="316" y="66" width="66" height="20" rx="4" fill="rgba(255,255,255,0.10)" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" clipPath="url(#aeOuter)" />
      <text x="349" y="79" fontFamily="Inter,sans-serif" fontSize="5.5" fill="rgba(255,255,255,0.85)" textAnchor="middle">Flexible Scheduling</text>

      {/* Programs section (white bg) */}
      <rect x="172" y="92" width="218" height="110" fill="white" />
      <text x="281" y="105" fontFamily="Inter,sans-serif" fontSize="7.5" fontWeight="700" fill="#111827" textAnchor="middle">Transform Your Practice With</text>
      <text x="281" y="115" fontFamily="Inter,sans-serif" fontSize="7.5" fontWeight="700" fill="#111827" textAnchor="middle">Our Yoga Programs</text>

      {/* 4 course cards */}
      {/* Card 1 - grey photo */}
      <rect x="175" y="120" width="46" height="60" rx="5" fill="white" stroke="#E5E7EB" strokeWidth="0.5" />
      <rect x="175" y="120" width="46" height="28" rx="5" fill="#D1D5DB" />
      <text x="198" y="156" fontFamily="Inter,sans-serif" fontSize="5.5" fontWeight="600" fill="#111827" textAnchor="middle">Beginner Yoga</text>
      <text x="198" y="165" fontFamily="Inter,sans-serif" fontSize="4.5" fill="#6B7280" textAnchor="middle">Build muscle and</text>
      <rect x="177" y="170" width="42" height="8" rx="3" fill="#111827" />
      <text x="198" y="176" fontFamily="Inter,sans-serif" fontSize="4.5" fill="white" textAnchor="middle">Enroll for $399/year</text>

      {/* Card 2 */}
      <rect x="225" y="120" width="46" height="60" rx="5" fill="white" stroke="#E5E7EB" strokeWidth="0.5" />
      <rect x="225" y="120" width="46" height="28" rx="5" fill="#A7C4A0" />
      <text x="248" y="156" fontFamily="Inter,sans-serif" fontSize="5.5" fontWeight="600" fill="#111827" textAnchor="middle">Flexibility Boost</text>
      <text x="248" y="165" fontFamily="Inter,sans-serif" fontSize="4.5" fill="#6B7280" textAnchor="middle">Improve range of</text>
      <rect x="227" y="170" width="42" height="8" rx="3" fill="#111827" />
      <text x="248" y="176" fontFamily="Inter,sans-serif" fontSize="4.5" fill="white" textAnchor="middle">Enroll for $399/year</text>

      {/* Card 3 */}
      <rect x="275" y="120" width="46" height="60" rx="5" fill="white" stroke="#E5E7EB" strokeWidth="0.5" />
      <rect x="275" y="120" width="46" height="28" rx="5" fill="#9CA3AF" />
      <text x="298" y="156" fontFamily="Inter,sans-serif" fontSize="5.5" fontWeight="600" fill="#111827" textAnchor="middle">Strength &amp; Core</text>
      <text x="298" y="165" fontFamily="Inter,sans-serif" fontSize="4.5" fill="#6B7280" textAnchor="middle">Burn fat and boost</text>
      <rect x="277" y="170" width="42" height="8" rx="3" fill="#111827" />
      <text x="298" y="176" fontFamily="Inter,sans-serif" fontSize="4.5" fill="white" textAnchor="middle">Enroll for $399/year</text>

      {/* Card 4 */}
      <rect x="325" y="120" width="46" height="60" rx="5" fill="white" stroke="#E5E7EB" strokeWidth="0.5" clipPath="url(#aeOuter)" />
      <rect x="325" y="120" width="46" height="28" rx="5" fill="#C4B5FD" clipPath="url(#aeOuter)" />
      <text x="348" y="156" fontFamily="Inter,sans-serif" fontSize="5.5" fontWeight="600" fill="#111827" textAnchor="middle">Stress Relief</text>
      <text x="348" y="165" fontFamily="Inter,sans-serif" fontSize="4.5" fill="#6B7280" textAnchor="middle">Boost your stamina</text>
      <rect x="327" y="170" width="42" height="8" rx="3" fill="#111827" />
      <text x="348" y="176" fontFamily="Inter,sans-serif" fontSize="4.5" fill="white" textAnchor="middle">Enroll for $399/year</text>

      {/* ── Testimonial section ── */}
      <rect x="172" y="202" width="218" height="88" fill="#F9FAFB" clipPath="url(#aeOuter)" />
      <text x="281" y="216" fontFamily="Inter,sans-serif" fontSize="7" fontWeight="700" fill="#111827" textAnchor="middle">Real Results from Real People</text>

      {/* Quote card */}
      <rect x="176" y="220" width="118" height="62" rx="6" fill="white" stroke="#E5E7EB" strokeWidth="0.5" />
      <text x="183" y="232" fontFamily="Georgia,serif" fontSize="14" fill="#6366F1">{'“'}</text>
      <text x="183" y="242" fontFamily="Inter,sans-serif" fontSize="6" fill="#374151">I never thought I&apos;d be able to stay</text>
      <text x="183" y="251" fontFamily="Inter,sans-serif" fontSize="6" fill="#374151">consistent, but this has completely</text>
      <text x="183" y="260" fontFamily="Inter,sans-serif" fontSize="6" fill="#374151">changed the game for me! I&apos;ve gained</text>
      <text x="183" y="269" fontFamily="Inter,sans-serif" fontSize="6" fill="#374151">so much strength, physically and</text>
      <text x="183" y="278" fontFamily="Inter,sans-serif" fontSize="6" fontWeight="600" fill="#111827">Jessica T.</text>

      {/* Photo */}
      <rect x="300" y="220" width="82" height="62" rx="6" fill="#D4C5B0" clipPath="url(#aeOuter)" />
      {/* Silhouette suggestion */}
      <ellipse cx="341" cy="241" rx="12" ry="12" fill="#B5A090" />
      <ellipse cx="341" cy="268" rx="22" ry="16" fill="#B5A090" />
    </svg>
  </div>
);

export default AiEditorCard;
